import { useState } from "react";
import { Client, Contact } from "../components/client/types";

/** Groups the open/close + selected-entity state ClientsPage's modals share. */
export function useClientModals() {
  const [isClientModalOpen, setIsClientModalOpen] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isDeleteClientDialogOpen, setIsDeleteClientDialogOpen] = useState(false);
  const [isLinkModalOpen, setIsLinkModalOpen] = useState(false);
  const [isUnlinkConfirmOpen, setIsUnlinkConfirmOpen] = useState(false);

  const [clientForModal, setClientForModal] = useState<Client | null>(null);
  const [contactForModal, setContactForModal] = useState<Contact | null>(null);

  const [returnToLinkMode, setReturnToLinkMode] = useState(false);
  const [newlyCreatedContact, setNewlyCreatedContact] = useState<any>(null);
  const [currentRelationshipData, setCurrentRelationshipData] = useState<any>(null);

  return {
    isClientModalOpen, setIsClientModalOpen,
    isContactModalOpen, setIsContactModalOpen,
    isDeleteClientDialogOpen, setIsDeleteClientDialogOpen,
    isLinkModalOpen, setIsLinkModalOpen,
    isUnlinkConfirmOpen, setIsUnlinkConfirmOpen,
    clientForModal, setClientForModal,
    contactForModal, setContactForModal,
    returnToLinkMode, setReturnToLinkMode,
    newlyCreatedContact, setNewlyCreatedContact,
    currentRelationshipData, setCurrentRelationshipData,
  };
}
